import { makeAutoObservable } from 'mobx';
import apiConfig from '../api/routes';
import { DownloadTemplate } from '../types';

class Templates {
  constructor() {
    makeAutoObservable(this);
  }


  downloadTemplateForRequestByEnum = async (data: DownloadTemplate) => {
    return await apiConfig.templateService.fetchTemplate(data);
  };
}

export const TemplatesStore = new Templates();
